var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMale1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.25 2C15.25 2.41421 15.5858 2.75 16 2.75H20.1893L15.1018 7.83758C13.717 6.68988 11.9391 6 10 6C5.58172 6 2 9.58172 2 14C2 18.4183 5.58172 22 10 22C14.4183 22 18 18.4183 18 14C18 12.0609 17.3101 10.283 16.1624 8.89824L21.25 3.81066V8C21.25 8.41421 21.5858 8.75 22 8.75C22.4142 8.75 22.75 8.41421 22.75 8V2C22.75 1.58579 22.4142 1.25 22 1.25H16C15.5858 1.25 15.25 1.58579 15.25 2Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMale1);
export default __webpack_public_path__ + "static/media/male-1.cc0b86b062a41bbc5ea7bd92ed2b37af.svg";
export { ForwardRef as ReactComponent };